import { notification } from 'antd';

import { ResponseError } from '@totem/types/error';

// Expired sessions (401s) are handled globally for every API request by
// installSessionExpiryHandling() in @totem/utilities/sessionExpiry.
export const CheckResponse = (response: Response) => response;

export const ShowErrorMessage = async (response: Response) => {
  try {
    const errResponse: ResponseError = await response.json();

    notification.error({
      message: errResponse.message,
      description: errResponse.developerMessage,
      duration: 5,
    });
  } catch {
    /* empty */
  }
};

export const CheckResponseShowError = (response: Response) => {
  if (response.status < 400) {
    return true;
  }

  ShowErrorMessage(response);

  return false;
};
